window.resetForm = (e) => {
  const form = e?.target?.form
  const inputs = form?.elements?.length ? Array.from(form.elements) : null

  if (!inputs) {
    return
  }

  inputs.forEach((i) => {
    if (i.value) {
      i.checked = ''
    }

    if (i.selected) {
      i.selected = false
    }

    if (i.checked) {
      i.checked = false
    }
  })
}
